import { AudioGraph } from "./AudioGraph";

export class AudioConnection
{
  private _graph:AudioGraph;
  private _fromID:number;
  private _fromIndex:number;

  private _toID:number;
  private _toIndex:number;
  private _connected:boolean = false;

  constructor( graph:AudioGraph, fromID:number, toID:number, fromIndex:number = undefined, toIndex:number = undefined)
  {
    this._graph = graph;
    this._fromID = fromID;
    this._fromIndex = fromIndex;
    this._toID = toID;
    this._toIndex = toIndex;
  }

  connect()
  {
    if ( this._connected )
    {
      return;
    }


    let fromNode = this._graph.getNode( this._fromID );

    if ( this._toID === 0 )
    {
      fromNode.node.connect( this._graph.context.destination );
      
      this._connected = true;
      return;
    }

    let toNode = this._graph.getNode( this._toID );

    if ( ! fromNode || ! toNode )
    {
      return;
    }



    if ( this._toIndex === undefined && this._fromIndex === undefined )
    {
      fromNode.node.connect( toNode.node ); 
    } 
    else
    {
      fromNode.node.connect( toNode.node, this._fromIndex, this._toIndex ); 
    }

    

    this._connected = true;
  }
}